import React from "react";
import { useVsiAppContext } from "../../stores/VsiApp";
const pathStyle = { strokeWidth: '0px'}
function VOILogo({ style, onClick }) {


  const { theme } = useVsiAppContext();

  return (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
      data-name="Layer 2"
      width="50px"
      height="64px"
      viewBox="0 -15 200 200"
    >
        <defs>
          <linearGradient id="voi-linear-gradient"
                        x1="50" y1="0"
                        x2="150" y2="0"
                          gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff" stopOpacity="30%"/>
      <stop offset=".99" stopColor="#fff"/>
    </linearGradient>
    <linearGradient id="voi-linear-gradient-2"
                    x1="56" y1="0"
                    x2="150" y2="0"
                    gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff" stopOpacity="30%"/>
      <stop offset=".99" stopColor="#fff"/>
      <stop offset="1" stopColor="#fff"/>
    </linearGradient>
        </defs>
            <path
        d="M58.49 63.4h73.23c12.26 0 22.19 9.94 22.19 22.19 0 6.13-2.49 11.68-6.5 15.69s-9.57 6.5-15.69 6.5H58.49V63.4z"
        className="cls-2"
        fill={theme === 'dark' ? 'url(#voi-linear-gradient-2)' : '#0ca9f2'}
        // fill={theme === 'dark' ? 'white' : '#fff'}
        style={{ ...pathStyle}}
      ></path>
            <path
        d="M117.3 149c0 12.26-9.94 22.19-22.19 22.19S72.92 161.25 72.92 149s9.94-22.19 22.19-22.19 22.19 9.94 22.19 22.19"
        className="cls-4"
        fill={theme === 'dark' ? 'white' : '#112660'}
        style={{ ...pathStyle}}
      ></path>
      <path
        d="M22.19 44.38h145.84c12.26 0 22.19-9.94 22.19-22.19S180.28 0 168.03 0H22.19v44.38z"
        className="cls-5"
        fill={theme === 'dark' ? 'url(#voi-linear-gradient)' : '#63ba3d'}
        style={{ ...pathStyle}}
      ></path>
            <path
        d="M80.69 85.59c0 12.26-9.94 22.19-22.19 22.19s-22.19-9.94-22.19-22.19S46.25 63.4 58.5 63.4s22.19 9.94 22.19 22.19"
        className="cls-1"
        fill={theme === 'dark' ? 'white' : '#0000d7'}
        style={{ ...pathStyle}}
      ></path>
      <path
        d="M44.38 22.19c0 12.26-9.94 22.19-22.19 22.19S0 34.44 0 22.19 9.94 0 22.19 0s22.19 9.94 22.19 22.19"
        className="cls-3"
        fill={theme === 'dark' ? 'white' : '#2e5d14'}
        style={{ ...pathStyle}}
      ></path>
    </svg>
  );
}

export default VOILogo;
